<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>捐赠支出及纳税调整明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033110">
        <thead>
          <tr>
            <td class="title01" rowspan="2">行次</td>
            <td class="title01" rowspan="2" style="width: 260px">项目</td>
            <td class="title01">账载金额</td>
            <td class="title01">以前年度结转可扣除的捐赠额</td>
            <td class="title01">按税收规定计算的扣除限额</td>
            <td class="title01">税收金额</td>
            <td class="title01">纳税调增金额</td>
            <td class="title01">纳税调减金额</td>
            <td class="title01">可结转以后年度扣除的捐赠额</td>
          </tr>
          <tr>
            <td class="title01">1</td>
            <td class="title01">2</td>
            <td class="title01">3</td>
            <td class="title01">4</td>
            <td class="title01">5</td>
            <td class="title01">6</td>
            <td class="title01">7</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td class="tilte01">1</td>
            <td class="title01">一、非公益性捐赠</td>
            <td class="d1"><el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2">--</td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">--</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="tilte01">2</td>
            <td class="title01">二、限额扣除的公益性捐赠（3+4+5+6）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v2x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">{{ parseFloatNum(data.v2x2.value) }}</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v2x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v2x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v2x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v2x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">{{ parseFloatNum(data.v2x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v2x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v2x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="tilte01">3</td>
            <td class="title01" style="padding-left: 34px">前三年度（<span style="padding-left: 52px">年</span>）</td>
            <td class="d1">--</td>
            <td class="d2"><el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5">--</td>
            <td class="d6"><el-input-number v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d7">--</td>
          </tr>

          <tr class="tr">
            <td class="tilte01">4</td>
            <td class="title01" style="padding-left: 34px">前二年度（<span style="padding-left: 52px">年</span>）</td>
            <td class="d1">--</td>
            <td class="d2"><el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5">--</td>
            <td class="d6"><el-input-number v-model.trim="data.v4x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d7"><el-input-number v-model.trim="data.v4x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="tilte01">5</td>
            <td class="title01" style="padding-left: 34px">前一年度（<span style="padding-left: 52px">年</span>）</td>
            <td class="d1">--</td>
            <td class="d2"><el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5">--</td>
            <td class="d6"><el-input-number v-model.trim="data.v5x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d7"><el-input-number v-model.trim="data.v5x7.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
          </tr>

          <tr class="tr">
            <td class="tilte01">6</td>
            <td class="title01" style="padding-left: 34px">本年（<span style="padding-left: 52px">年</span>）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v6x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">--</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v6x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v6x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x3.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v6x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v6x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v6x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v6x4.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d5">
              {{ parseFloatNum(data.v6x5.value) }}
            </td>
            <td class="d6">--</td>
            <td class="d7">{{ parseFloatNum(data.v6x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="tilte01">7</td>
            <td class="title01">三、全额扣除的公益性捐赠</td>
            <td class="d1">{{ parseFloatNum(data.v7x1.value) }}</td>
            <td class="d2">--</td>
            <td class="d3">--</td>
            <td class="d4">{{ parseFloatNum(data.v7x4.value) }}</td>
            <td class="d5">--</td>
            <td class="d6">--</td>
            <td class="d7">--</td>
          </tr>

          <tr class="tr" v-for="(item, index) of data.v8x1.value" :key="index">
            <td class="tilte01">{{ index + 8 }}</td>
            <td class="title01">
              <div style="display: flex; align-items: center">
                <el-button type="primary" link @click="options1Add">增行</el-button>
                <el-button type="primary" link @click="options1Del(index)" :style="{ visibility: index > 0 ? 'visible' : 'hidden' }">删除</el-button>
                <el-select v-model="item.type" style="margin-left: 10px" placeholder="" :empty-values="[null, undefined]">
                  <el-option v-for="(item, index) of options1" :key="index" :label="item.label" :value="item.value" />
                </el-select>
              </div>
            </td>
            <td class="d1">
              <el-input-number v-model.trim="item.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td class="d2">--</td>
            <td class="d3">--</td>
            <td class="d4">
              {{ parseFloatNum(item.value) }}
            </td>
            <td class="d5">--</td>
            <td class="d6">--</td>
            <td class="d7">--</td>
          </tr>

          <tr class="tr">
            <td class="tilte01">{{ data.v8x1.value.length + 8 }}</td>
            <td class="td_l tilte01">合计（1+2+7）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v11x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">{{ parseFloatNum(data.v11x2.value) }}</td>
            <td class="d3">
              <!-- 考题 -->
              <taxQue :data="data.v11x3" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x3.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x3.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x3.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d4">
              <!-- 考题 -->
              <taxQue :data="data.v11x4" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v11x4.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v11x4.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v11x4.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d5">{{ parseFloatNum(data.v11x5.value) }}</td>
            <td class="d6">{{ parseFloatNum(data.v11x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v11x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="tilte01">附列资料</td>
            <td class="td_l tilte01">2015年度至本年度发生的公益性扶贫捐赠合计金额</td>
            <td class="d1"><el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2">--</td>
            <td class="d3">--</td>
            <td class="d4"><el-input-number v-model.trim="data.v12x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">--</td>
            <td class="d6">--</td>
            <td class="d7">--</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        for (let column = 1; column <= 7; column++) {
          // 1-7列 2行=3+4+5+6
          data.value[`v2x${column}`].value = new Big(data.value[`v3x${column}`].value)
            .plus(data.value[`v4x${column}`].value)
            .plus(data.value[`v5x${column}`].value)
            .plus(data.value[`v6x${column}`].value)
            .round(2)
            .toNumber();
          // 1-7列 11行=1+2+7
          data.value[`v11x${column}`].value = new Big(data.value[`v1x${column}`].value).plus(data.value[`v2x${column}`].value).plus(data.value[`v7x${column}`].value).round(2).toNumber();
          // 第6行第4列 用（第6行第1列+第3行第6列+第4行第6列+第5行第6列）的和，与第6行第3列的数值做比较，谁小取谁
          data.value.v6x4.value = Math.min(
            new Big(data.value.v6x1.value).plus(data.value.v3x6.value).plus(data.value.v4x6.value).plus(data.value.v5x6.value).round(2).toNumber(),
            new Big(data.value.v6x3.value).round(2).toNumber()
          );
          // 第6行第5列数据计算逻辑：第6行第1列-（第6行第4列-第3行第6列-第4行第6列-第5行第6列）
          data.value.v6x5.value = new Big(data.value.v6x1.value)
            .minus(new Big(data.value.v6x4.value).minus(data.value.v3x6.value).minus(data.value.v4x6.value).minus(data.value.v5x6.value))
            .round(2)
            .toNumber();
          // 第6行第7列数据，取第6行第5列的数据
          data.value.v6x7.value = data.value.v6x5.value;
          // 第7行第1列=第8行多行数据之和
          data.value.v7x1.value = new Big(
            data.value.v8x1.value.reduce((prev, cur) => {
              return new Big(cur.value).plus(prev).round(2).toNumber();
            }, 0)
          )
            .round(2)
            .toNumber();
          // 第7行第4列=第7行第1列
          data.value.v7x4.value = data.value.v7x1.value;

          syncAnswer({
            mode,
            newVal,
            oldVal,
            data,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

const options1 = [
  { label: "", value: "" },
  { label: "0601|扶贫捐赠", value: "0601" },
  { label: "2901|北京2022年冬奥会、冬残奥会、测试赛捐赠", value: "2901" },
  { label: "2902|杭州2022年亚运会捐赠", value: "2902" },
];

const options1Add = () => {
  data.value.v8x1.value.push({
    type: "",
    value: 0,
  });
};

const options1Del = (index) => {
  data.value.v8x1.value.splice(index, 1);
};

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;

  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033110">
  <thead>
    <tr>
      <td class="title01" rowspan="2">行次</td>
      <td class="title01" rowspan="2">项目</td>
      <td class="title01">账载金额</td>
      <td class="title01">以前年度结转可扣除的捐赠额</td>
      <td class="title01">按税收规定计算的扣除限额</td>
      <td class="title01">税收金额</td>
      <td class="title01">纳税调增金额</td>
      <td class="title01">纳税调减金额</td>
      <td class="title01">可结转以后年度扣除的捐赠额</td>
    </tr>
    <tr>
      <td class="title01">1</td>
      <td class="title01">2</td>
      <td class="title01">3</td>
      <td class="title01">4</td>
      <td class="title01">5</td>
      <td class="title01">6</td>
      <td class="title01">7</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td class="tilte01">1</td>
      <td class="title01">一、非公益性捐赠</td>
      <td class="d1"><input type="text" value="0" class="i1 input2" daan="0.00" /></td>
      <td class="d2">*</td>
      <td class="d3">*</td>
      <td class="d4">*</td>
      <td class="d5"><input type="text" value="0" class="i1 input1" daan="0.00" /></td>
      <td class="d6">*</td>
      <td class="d7">*</td>
    </tr>
    <tr class="tr">
      <td class="tilte01">2</td>
      <td class="title01">二、限额扣除的公益性捐赠（3+4+5+6）</td>
      <td class="d1"><input type="text" value="0" class="i2 input1" daan="20000.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i2 input1" daan="84333.50" /></td>
      <td class="d4"><input type="text" value="0" class="i2 input1" daan="20000.00" /></td>
      <td class="d5"><input type="text" value="0" class="i2 input1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i2 input1" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i2 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="tilte01">3</td>
      <td class="title01">前三年度（20**年）</td>
      <td class="d1">*</td>
      <td class="d2"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d3">*</td>
      <td class="d4">*</td>
      <td class="d5">*</td>
      <td class="d6"><input type="text" value="0" class="i3 input1" daan="0.00" /></td>
      <td class="d7">*</td>
    </tr>

    <tr class="tr">
      <td class="tilte01">4</td>
      <td class="title01">前二年度（20**年）</td>
      <td class="d1">*</td>
      <td class="d2"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
      <td class="d3">*</td>
      <td class="d4">*</td>
      <td class="d5">*</td>
      <td class="d6"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i4 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="tilte01">5</td>
      <td class="title01">前一年度（20**年）</td>
      <td class="d1">*</td>
      <td class="d2"><input type="text" value="0" class="i5 input1" daan="0.00" /></td>
      <td class="d3">*</td>
      <td class="d4">*</td>
      <td class="d5">*</td>
      <td class="d6"><input type="text" value="0" class="i5 input1" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i5 input1" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="tilte01">6</td>
      <td class="title01">本年（20**年）</td>
      <td class="d1"><input type="text" value="0" class="i6 input2 c20" daan="20000.00" /></td>
      <td class="d2">*</td>
      <td class="d3"><input type="text" value="0" class="i6 input1 i12" daan="84333.50" /></td>
      <td class="d4"><input type="text" value="0" class="i6 input1 e20" daan="20000.00" /></td>
      <td class="d5"><input type="text" value="0" class="i6 input1 f20" daan="0.00" /></td>
      <td class="d6">*</td>
      <td class="d7"><input type="text" value="0" class="i6 input1 h20" daan="0.00" /></td>
    </tr>

    <tr class="tr">
      <td class="tilte01">7</td>
      <td class="title01">三、全额扣除的公益性捐赠</td>
      <td class="d1"><input type="text" value="0" class="i7 input1" daan="0.00" /></td>
      <td class="d2">*</td>
      <td class="d3">*</td>
      <td class="d4"><input type="text" value="0" class="i7 input1" daan="0.00" /></td>
      <td class="d5">*</td>
      <td class="d6">*</td>
      <td class="d7">*</td>
    </tr>

    <tr class="tr">
      <td class="tilte01">8</td>
      <td class="title01">
        <input type="text" style="display: none; background: rgb(235, 235, 235)" readonly="readonly" daan="0.00" />
        <select class="input2">
          <option>0601/扶贫捐赠</option>
          <option>2901|北京2022年冬奥会、冬残奥会、测试赛捐赠</option>
          <option>2902/杭州2022年亚运会捐赠</option>
        </select>
      </td>
      <td class="d1"><input type="text" value="0" class="i8 input2" daan="0.00" /></td>
      <td class="d2">*</td>
      <td class="d3">*</td>
      <td class="d4"><input type="text" value="0" class="i8 input1" daan="0.00" /></td>
      <td class="d5">*</td>
      <td class="d6">*</td>
      <td class="d7">*</td>
    </tr>
    <tr class="tr">
      <td class="tilte01">9</td>
      <td class="td_l tilte01">合计（1+2+7）</td>
      <td class="d1"><input type="text" value="0" class="i9 input1" daan="20000.00" /></td>
      <td class="d2"><input type="text" value="0" class="i9 input1" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i9 input1" daan="84333.50" /></td>
      <td class="d4"><input type="text" value="0" class="i9 input1" daan="20000.00" /></td>
      <td class="d5"><input type="text" value="0" class="i9 input1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i9 input1" daan="0.00" /></td>
      <td class="d7"><input type="text" value="0" class="i9 input1" daan="0.00" /></td>
    </tr>
    <tr class="tr">
      <td class="tilte01">10</td>
      <td class="td_l tilte01">2015年度至本年度发生的公益性扶贫捐赠合计金额</td>
      <td class="d1"><input type="text" value="0" class="i10 input2" daan="0.00" /></td>
      <td class="d2">--</td>
      <td class="d3">--</td>
      <td class="d4"><input type="text" value="0" class="i10 input2" daan="0.00" /></td>
      <td class="d5">--</td>
      <td class="d6">--</td>
      <td class="d7">--</td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
